import * as type from '../types';

export function stationSearchRequest(value) {
  return {
    type: type.STATION_SEARCH_REQUESTED,
    payload: value,
  };
}
export function stationSearchSucceeded(data) {
  return {
    type: type.STATION_SEARCH_SUCCEEDED,
    payload: data,
  };
}
export function stationSearchFailed() {
  return {
    type: type.STATION_SEARCH_FAILED,
  };
}

export function getStationRequested(organizationId) {
  return {
    type: type.GET_STATIONS_REQUESTED,
    payload: organizationId,
  };
}
export function getStationsSucceeded(data) {
  return {
    type: type.GET_STATIONS_SUCCEEDED,
    payload: data,
  };
}
export function getStationsFailed() {
  return {
    type: type.GET_STATIONS_FAILED,
  };
}
export function setStations(data) {
  return {
    type: type.SET_STATIONS,
    payload: data,
  };
}
